import { useTexts } from '../hooks/useTexts'
import { createValidateName } from '../hooks/validations/createValidateName'

import { form } from '../formState'

export function Name() {
  const texts = useTexts()

  form.useAddFieldValidation<'name'>('name', (field, _formApi) => {
    const validationName = createValidateName(texts, field.value)
    return validationName.nameRequiredError?.message || validationName.nameMaxLengthError?.message
  })

  return (
    <form.TextField
      testId="name"
      name="name"
      label={texts.labels.name}
      placeholder={texts.placeholders.name}
      validateOn="change"
    />
  )
}
